import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ClientDetails } from '../../../../../projects/shared-lib/src/lib/models/client-details';
import { MessageAction, MessageObserverService } from '../../../../../projects/shared-lib/src/lib/services/message-observer.service';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormErrorMessageComponent } from '../../../shared/component/form/form-error-message/form-error-message.component';
import { EmailValidatorDirective } from '../../../shared/directive/email-validator.directive';
import { EqualValidatorDirective } from '../../../shared/directive/equal-validator.directive';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'tw-client-guest',
    templateUrl: './client-guest.component.html',
    styleUrls: ['./client-guest.component.css'],
    imports: [FormsModule, MatFormField, MatLabel, MatInput, MatError, FormErrorMessageComponent, EmailValidatorDirective, EqualValidatorDirective, MatButton, TranslatePipe]
})
export class ClientGuestComponent implements OnInit {
    @Input() isFree = false;
    @Output() clientChange = new EventEmitter<ClientDetails>();
    @Output() wacthNext = new EventEmitter<any>();
    @ViewChild('clientGuestForm', { static: true }) clientGuestForm;

    constructor(private messageObserverService: MessageObserverService, public translate: TranslateService) {
    }

    ngOnInit() {
        this.clientGuestForm.statusChanges.subscribe(
            result => {
                //console.log(result);
                this.clientChange.emit(<ClientDetails>{ ...this.clientGuestForm.value, status: result });
            }
        );
    }

    next() {

        if (!this.clientGuestForm.valid) {
            this.clientGuestForm.control.markAllAsTouched();
            this.messageObserverService.addMessage(<MessageAction>{ dialog: true, message: 'error.fillRequired', translate: true });
            return;
        }
        this.wacthNext.emit(new Date());
    }
}
